import axios from "axios";

import {
  GET_USER_COMPANY_INFO,
  GET_USER_EMAIL,
  GET_USER_PERSONAL_INFO,
  DUPLICATE_EMAIL_FAIL,
  DUPLICATE_EMAIL_SUCCESS,
  DUPLICATE_EMAIL_REQUEST,
  SEND_DATA_SUCCESS,
  SEND_DATA_REQUEST,
  SEND_DATA_FAIL,
  GET_IPDATA_REQUEST,
  GET_IPDATA_SUCCESS,
  GET_IPDATA_FAIL,
  GET_PAGE_NAME,
  GET_PAGE_NAME_FAIL,
  SEND_TWILIO_REQ,
  SEND_TWILIO_SUCCESS,
  SEND_TWILIO_FAIL,
  FREETRIAL_CREATE_REQ,
  FREETRIAL_CREATE_SUCCESS,
  FREETRIAL_CREATE_FAIL,
  REDIRECT_STATUS_CHECKED,
  SUB_TO_PRODUCT_LIST_REQ,
  SUB_TO_PRODUCT_LIST_SUCCESS,
  SUB_TO_PRODUCT_LIST_FAIL,
  SEND_NOTIFICATION_UK_REQ,
  SEND_NOTIFICATION_UK_SUCCESS,
  SEND_NOTIFICATION_UK_FAIL,
  SEND_CHILI_REQ,
  SEND_CHILI_SUCCESS,
  SEND_CHILI_FAIL,
} from "../constants";

const { REACT_APP_IPAPI_API_KEY } = process.env;

export const setUserEmail = (email) => (dispatch) => {
  dispatch({ type: GET_USER_EMAIL, payload: email });
};

export const setUserCompanyInfo =
  (companyName, employeeRange) => (dispatch) => {
    dispatch({
      type: GET_USER_COMPANY_INFO,
      companyName,
      employeeRange,
    });
  };

export const setUserPersonalInfo =
  (firstName, lastName, phone) => (dispatch) => {
    dispatch({
      type: GET_USER_PERSONAL_INFO,
      firstName,
      lastName,
      phone,
    });
  };

export const duplicateEmailCheck = (email) => async (dispatch) => {
  try {
    dispatch({ type: DUPLICATE_EMAIL_REQUEST });

    const { data } = await axios.get(
      "https://my.workforce.com/try/validate_email?email=" + email
    );
    if (data) {
      dispatch({ type: DUPLICATE_EMAIL_SUCCESS });
    } else {
      dispatch({
        type: DUPLICATE_EMAIL_FAIL,
        payload: "Email already registered: Please log in",
      });
    }
  } catch (error) {
    dispatch({
      type: DUPLICATE_EMAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendDataToNetlify = (data) => async (dispatch) => {
  try {
    dispatch({ type: SEND_DATA_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post("/.netlify/functions/zapier", data, config);
    if (res) {
      dispatch({ type: SEND_DATA_SUCCESS });
    } else {
      dispatch({
        type: SEND_DATA_FAIL,
        payload: "server error, please try again",
      });
    }
  } catch (error) {
    dispatch({
      type: SEND_DATA_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getUserIpData = () => async (dispatch) => {
  try {
    dispatch({ type: GET_IPDATA_REQUEST });
    const { data } = await axios.get(
      `https://ipapi.co/json/?key=${REACT_APP_IPAPI_API_KEY}`
    );
    dispatch({ type: GET_IPDATA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_IPDATA_FAIL,
      payload: {
        city: "",
        region: "",
        // eslint-disable-next-line
        region_code: "",
        country: "",
        // eslint-disable-next-line
        country_name: "",
        // eslint-disable-next-line
        country_code: "",
        // eslint-disable-next-line
        continent_code: "",
        // eslint-disable-next-line
        in_eu: "",
        postal: "",
        latitude: "",
        longitude: "",
        timezone: "",
        // eslint-disable-next-line
        country_calling_code: "",
      },
      payloadError:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getPageUrl = (pageUrl) => (dispatch) => {
  if (pageUrl) {
    dispatch({ type: GET_PAGE_NAME, payload: pageUrl });
  } else {
    dispatch({
      type: GET_PAGE_NAME_FAIL,
      payload: "No Page URL Found",
    });
  }
};

export const sendTwilio = (userData) => async (dispatch) => {
  try {
    dispatch({ type: SEND_TWILIO_REQ });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      "/.netlify/functions/twilio",
      userData,
      config
    );
    if (res) {
      dispatch({ type: SEND_TWILIO_SUCCESS });
      // google tag for mobile signups
      let dataLayer = window.dataLayer;
      dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "mobile_signup",
        mobile_signup: "sms_sent",
      });
    } else {
      dispatch({
        type: SEND_TWILIO_FAIL,
      });
    }
  } catch (error) {
    dispatch({
      type: SEND_TWILIO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendTwilioJustPhone = (userData) => async (dispatch) => {
  try {
    dispatch({ type: SEND_TWILIO_REQ });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      "/.netlify/functions/twilioPhone",
      userData,
      config
    );
    if (res) {
      dispatch({ type: SEND_TWILIO_SUCCESS });
    } else {
      dispatch({
        type: SEND_TWILIO_FAIL,
      });
    }
  } catch (error) {
    dispatch({
      type: SEND_TWILIO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createFreeTrial = (userData) => async (dispatch) => {
  try {
    dispatch({ type: FREETRIAL_CREATE_REQ });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      "https://my.tanda.co/api/v2/sign_up",
      userData,
      config
    );
    if (data) {
      dispatch({ type: FREETRIAL_CREATE_SUCCESS, payload: data });
    }
  } catch (error) {
    dispatch({
      type: FREETRIAL_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const checkRedirectStatus = () => (dispatch) => {
  dispatch({ type: REDIRECT_STATUS_CHECKED });
};

export const addProductList = (userData) => async (dispatch) => {
  try {
    dispatch({ type: SUB_TO_PRODUCT_LIST_REQ });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      "/.netlify/functions/productList",
      userData,
      config
    );
    if (res) {
      dispatch({ type: SUB_TO_PRODUCT_LIST_SUCCESS });
    } else {
      dispatch({
        type: SUB_TO_PRODUCT_LIST_FAIL,
      });
    }
  } catch (error) {
    dispatch({
      type: SUB_TO_PRODUCT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendNotificationToUK = (data) => async (dispatch) => {
  try {
    dispatch({ type: SEND_NOTIFICATION_UK_REQ });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      "/.netlify/functions/notificationUK",
      data,
      config
    );
    if (res) {
      dispatch({ type: SEND_NOTIFICATION_UK_SUCCESS });
    } else {
      dispatch({
        type: SEND_NOTIFICATION_UK_FAIL,
        payload: "server error, please try again",
      });
    }
  } catch (error) {
    dispatch({
      type: SEND_NOTIFICATION_UK_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createChiliDemo = (userData) => async (dispatch) => {
  try {
    dispatch({ type: SEND_CHILI_REQ });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      "https://api.chilipiper.com/marketing/workforce",
      userData,
      config
    );
    if (await data) {
      dispatch({ type: SEND_CHILI_SUCCESS, payload: data });
    }
  } catch (error) {
    dispatch({
      type: SEND_CHILI_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendChiliToZap = async (userData) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      "/.netlify/functions/chili",
      userData,
      config
    );
    if (await data) {
      console.log("success");
    }
  } catch (error) {
    console.log(error);
  }
};
